import { areObjectsEqual } from './_internal/areObjectsEqual';

/**
 * Checks if two values are equal, including support for `Date`, `RegExp`, and deep object comparison.
 */
export function isEqual(a: any, b: any): boolean {
  if (typeof a === typeof b) {
    switch (typeof a) {
      case 'bigint':
      case 'string':
      case 'boolean':
      case 'symbol':
      case 'undefined':
        return a === b;
      case 'number':
        return a === b || Object.is(a, b);
      case 'function':
        return a === b;
      case 'object':
        return areObjectsEqual(a, b);
    }
  }
  return areObjectsEqual(a, b);
}
